import bus from '@/utils/bus';
import validation from '@/utils/validation';
import { isEqual, merge } from 'lodash';

let beforeChangeItem = {};

export default {
  props: {
    paths: {
      type: Object,
      default: () => ({
        tree: '',
        data: '',
      }),
    },
    values: {
      type: Object,
      required: true,
    },
    value: Boolean,
  },
  data() {
    return {
      item: this.values,
      valid: true,
      disabledSave: true,
      rules: {
        ...validation,
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    show: {
      immediate: true,
      handler: 'setDialogActivated',
    },
    item: {
      deep: true,
      handler: 'setDisabledSave',
    },
  },
  methods: {
    save() {
      bus.$emit('change-data', this.paths, this.values);
      this.show = false;
    },
    cancel() {
      merge(this.item, beforeChangeItem);
      beforeChangeItem = {};
      this.show = false;
    },
    async setDialogActivated(show) {
      if (show) {
        this.onShow();
        beforeChangeItem = merge({}, this.values);
        this.item = this.values;
        this.disabledSave = true;
      } else {
        this.$refs.form.resetValidation();
      }
    },
    onShow() {},
    setDisabledSave(item) {
      this.disabledSave = !this.valid || isEqual(beforeChangeItem, item);
    },
  },
};
